import { removeComma } from 'utils'

/**
 * Trust-bucket opening balances. Mirrors the backend rule in
 * `modules/loan/servicing/opening-balance.utils.ts` — keep the two in step.
 *
 * Historically a loan arrived in servicing with its trust buckets already carrying a
 * balance and nothing on the ledger to explain it: every running total was simply *seeded*
 * from the loan's configured amount. Loans moved to servicing now get a real opening
 * Deposit row per funded bucket instead.
 *
 * Both shapes have to keep working, so every place that walks a bucket's rows seeds its
 * running balance through `openingBalanceSeed`: zero once an explicit opening deposit
 * exists (the row supplies the money), otherwise the configured amount as before. Seeding
 * both would double the balance.
 */

export const OPENING_BALANCE_REFERENCE = 'Opening Balance'

export const isOpeningBalanceRow = (row: Record<string, any>): boolean => row?.isOpeningBalance === true

export const hasOpeningBalanceRow = (rows: Record<string, any>[] = []): boolean => rows.some(isOpeningBalanceRow)

/**
 * Opening balance to start a bucket's running total from. Returns 0 when the bucket already
 * carries an explicit opening deposit, so the row is counted once rather than twice.
 */
export const openingBalanceSeed = (configuredAmount: any, rows: Record<string, any>[] = []): number =>
  hasOpeningBalanceRow(rows) ? 0 : removeComma(configuredAmount)
